<template>
  <AdminContent v-if="showAdminUI" />
  <SiteContent v-else />
</template>

<script>
import AdminContent from '@/ui/structure/adminContent'
import SiteContent from '@/ui/structure/siteContent'

export default {
  name: 'ContentWrapper',
  components: {
    AdminContent,
    SiteContent
  },
  computed: {
    showAdminUI () {
      return this.$route.meta.requiresAdmin || false
    }
  }
}
</script>
